<template>
    <div id="favorites-product-edit" v-if="product">
        <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <button @click.prevent="product = null" type="button" class="close float-right">
                                    <span aria-hidden="true"><div class="icon icon-close"></div></span>
                                </button>
                            </div>
                            <div class="col-12 text-center content">
                                <div class="title">{{ $t('user.favorites.edit') }}</div>
                                <img :src="product.thumb" />
                                <div class="productName">
                                    {{product.name}}
                                </div>
                                <div class="dropdown">
                                    <button v-if="selectedCategory != ''" class="btn btn-outline-medium-gray btn-outline-light btn-dropdown w-100 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <template v-if="selectedCategory == 'Moji priljubljeni'">
                                            {{ $t('user.favorites.title') }}
                                        </template>
                                        <template v-else>
                                            {{selectedCategory}}
                                        </template>
                                    </button>
                                    <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton">
                                        <div class="dropdown-item" :key="0" @click="selectCategory(0)">{{ $t('user.favorites.title') }}</div>
                                        <div class="dropdown-item" v-for="category in categories" :key="category.id" @click="selectCategory(category.id)">{{category.title}}</div>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-outline-green w-100" @click="saveCategory()">{{ $t('user.favorites.save') }}</button>
                                <div class="delete" @click="deleteFavorite()">{{ $t('user.favorites.remove') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" @click="product = null"></div>
    </div>
</template>

<script>

import Xhr from '@Core/xhr';
import forEach from '@Utils/forEach'

export default {

    data() {
        return {
            product: null,
            favoriteId: null,
            inCategory: 0,
            selectedCategory: "",
            categories: []
        }
    },

    created() {
        App.dispatcher.listen('favorites-product-edit.open', (editResponse) => {
            new Xhr().get(`/product/${editResponse.pid}`).then(product => {
                this.product = product;
                this.favoriteId = editResponse.fid;
            })

            new Xhr().get('/favorites/categories').then((response) => {
                this.categories = response;
                this.inCategory = editResponse.cid;
                this.getCategoryName();
            })
        })
    },

    methods: {
        getCategoryName() {
            if(this.inCategory == 0) {
                this.selectedCategory = "Moji priljubljeni";
            } else {
                forEach(this.categories, (index, category) => {
                    if(category.id == this.inCategory) {
                        this.selectedCategory = category.title;
                    }
                })
            }
        },

        selectCategory(id) {
            this.inCategory = id;
            this.getCategoryName();
        },

        saveCategory() {
            new Xhr({ fid: this.favoriteId, cid: this.inCategory}).post('/favorites/save-category-to-product').then((response) => {
                App.dispatcher.fire('favorites.loaded', response);
                this.close();
            })
        },

        deleteFavorite() {
            new Xhr({  id: this.favoriteId }).post('/favorites/remove').then((response) => {
                App.dispatcher.fire('favorites.loaded', response);
                this.close();
            })

        },

        close() {
            this.selectedCategory = "";
            this.product = null;
        }
    }


}
</script>
